import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Static-root_30sbL",
  "wrapper": "Static-wrapper_1tjiY",
  "illustration": "Static-illustration_193XE",
  "content": "Static-content_1H8ki",
  "title": "Static-title_1TfM-",
  "buttonContainer": "Static-buttonContainer_Qmbck"
};
function Static({
  title,
  illustration,
  children,
  buttons,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx("article", {
    className: clsx(styles.root, className),
    ...extraProps,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [illustration ? /*#__PURE__*/_jsx("div", {
        className: styles.illustration,
        children: /*#__PURE__*/_jsx("img", {
          src: illustration,
          alt: ""
        })
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [title ? /*#__PURE__*/_jsx("h1", {
          className: styles.title,
          children: title
        }) : null, children, buttons ? /*#__PURE__*/_jsx("p", {
          className: styles.buttonContainer,
          children: buttons
        }) : null]
      })]
    })
  });
}
export default Static;